module.exports = __webpack_public_path__ + "img/icon-right-arrow.405ab81d.png";